<template>
    <main-layout>
        <template #header>
            <main-header :title="'데이터 마이그레이션' | translate"></main-header>
        </template>

        <template #toolbar>
            <main-toolbar></main-toolbar>
        </template>

        <template #body>
            <main-body style="position: relative">
                <div v-show="loading" class="fill-height" style="z-index: 1000; position: absolute; width: 100%;">
                    <div class="loading-overlay d-flex justify-center align-center fill-height"
                         style="background-color: rgba(203, 203, 203, 0.2);"
                         click.stop.prevent
                    >
                        <v-progress-circular size="46" color="primary" indeterminate />
                        <span class="ml-7"> 로딩중 .. </span>
                    </div>
                </div>
                <div class="body-container" style="position: absolute">
                    <div class="mb-5 d-flex">
                        <h3> CMS 정보 등록하기 </h3>
                    </div>
                    <div style="width: 400px;">
                        <v-select
                                :items="cmsTypes"
                                label="CMS 종류를 선택해주세요"
                                :value="cmsType"
                                outlined
                                dense
                                @change="onCmsTypeChange"
                        ></v-select>
                    </div>
                    <div class="d-flex">
                        <div class="mr-5">
                            <v-text-field
                                v-model="rentalcompanyId"
                                lavel="rentalcompanyId"
                                placeholder="rentalcompanyId"
                            />
                        </div>
                        <div style="width: 400px;" class="mr-4">
                            <xlsx-controller ref="onlyCmsXlsx" label="cms-info" @fileIsReady="cmsInfoFileIsReady"/>
                        </div>
                        <div class="mt-4 ml-3">
                            <v-btn small color="primary" :disabled="!(isCmsInfoFile&&rentalcompanyId)" @click="onOnlyCmsRegister">등록하기</v-btn>
                        </div>
                    </div>
                    <div class="d-flex mt-10">
                        CMS정보 총 {{ resultOfOnlyCms.totalCount }}개 중  성공: {{ successCountOfOnlyCms }}개, 실패: {{ failCountOfOnlyCms }}개
                    </div>
                    <div style="width: 60%" class="mt-5">
                        <table class="data-table">
                            <tr>
                                <th style="width: 15%">거래처번호</th>
                                <th style="width: 35%">거래처이름</th>
                                <th style="width: 50%">실패사유</th>
                            </tr>
                            <tr v-for="(f, fIdx) in resultOfOnlyCms.failData" :key="`ff-${fIdx}`">
                                <td>{{ f.accountId }}</td>
                                <td>{{ f.csName }}</td>
                                <td>{{ f.errorReason }}</td>
                            </tr>
                        </table>
                    </div>

                    <hr style="margin-top: 200px;" />
                    <hr class="mt-2" />
                    <div class="mb-5 d-flex mt-10" >
                        <h3> 마이그레이션 Excel 만들기 </h3>
                    </div>
                    <div style="width: 400px;">
                        <v-select
                                :items="cmsTypes"
                                label="CMS 종류를 선택해주세요"
                                :value="cmsType"
                                outlined
                                dense
                                @change="onCmsTypeChange"
                        ></v-select>
                    </div>
                    <div class="d-flex">
                        <div style="width: 400px;" class="mr-4">
                            <xlsx-controller ref="cmsInfoXlsx" label="cms-info" @fileIsReady="cmsInfoFileIsReady"/>
                        </div>
                        <div style="width: 400px;">
                            <xlsx-controller ref="baseInfoXlsx" label="base-info" @fileIsReady="baseInfoFileIsReady"/>
                        </div>
                        <div class="mt-4 ml-3">
                            <v-btn small color="primary" :disabled="!(isCmsInfoFile&&isBaseInfoFile)" @click="onAnalysis">조회하기</v-btn>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex mb-5">
                            <h4 class="mr-4">성공 데이터</h4>
                            <span class="mr-4">기본정보 총 {{ totalCountOfBaseInfo }}개 중 {{ successCountOfBaseInfo }}개</span>
                            <v-btn small color="primary" :disabled="!successCountOfBaseInfo" @click="downloadSuccessFile">download excel file</v-btn>
                        </div>
                        <div class="d-flex overflow-x-auto data-table-wrap">
                            <table class="data-table">
                                <tr>
                                    <th v-for="(header,idx) in baseInfoHeader" :key="idx" style="min-width: 200px;">{{ header }}</th>
                                </tr>
                                <tr v-for="(d, cIdx) in resultOfMerge.mergedData" :key="`c-${cIdx}`">
                                    <td v-for="(h, hIdx) in baseInfoHeaderVerEn" :key="`h-${hIdx}`">{{ d[h] }}</td>
                                </tr>
                                <tr></tr>
                            </table>
                        </div>
                    </div>
                    <div class="mt-5">
                        <div class="d-flex mb-5">
                            <h4 class="mr-4">실패 데이터</h4>
                            <span class="mr-4">기본정보 {{ failCountOfBaseInfo }}개, CMS정보 총 {{totalCountOfCmsInfo}} 개중 {{ failCountOfCmsInfo }} 개</span>
                            <v-btn class="mr-4" small color="primary" :disabled="!(failCountOfBaseInfo || failCountOfCmsInfo)" @click="downloadFailFiles">download excel file</v-btn>
                       </div>
                        <div class="d-flex mb-5">
                            <span> ** 파란선 위는 기본정보에서 실패한 데이터이고, 아래는 CMS정보에서 실패한 데이터입니다. 해당 내용은 각각의 엑셀 파일로 다운로드 됩니다.</span>
                        </div>
                        <div class="d-flex overflow-x-auto data-table-wrap">
                            <table class="data-table">
                                <tr>
                                    <th style="width: 300px">거래처</th>
                                    <th class="d-flex pl-3 align-center"> <span>실패이유</span></th>
                                </tr>
                                <tr v-for="(f, fIdx) in resultOfMerge.failedData" :key="`f-${fIdx}`">
                                    <td style="width: 300px">{{f.accountName}}</td>
                                    <td class="d-flex pl-3 align-center"> {{f.errMsg}}</td>
                                </tr>
                                <tr>
                                    <td style="height: 2px; border: 1px solid royalblue;" v-if="failCountOfBaseInfo"></td>
                                    <td style="height: 2px; border: 1px solid royalblue;" v-if="failCountOfBaseInfo"></td>
                                </tr>
                                <tr v-for="(o, oIdx) in resultOfMerge.onlyCMSData" :key="`o-${oIdx}`">
                                    <td style="width: 300px">{{o.accountName}}</td>
                                    <td class="d-flex pl-3 align-center"> 해당 CMS의 회사명과 같은 거래처명을 가진 기본정보가 없거나, CMS상태가 정상적이지 않습니다.</td>
                                </tr>
                                <tr v-for="(d, dIdx) in resultOfMerge.duplicateCMSData" :key="`d-${dIdx}`">
                                    <td style="width: 300px">{{d.accountName}}</td>
                                    <td class="d-flex pl-3 align-center"> 중복된 CMS가 있습니다. </td>
                                </tr>
                                <tr></tr>
                            </table>
                        </div>
                    </div>

                  <hr style="margin-top: 200px;" />
                  <hr class="mt-2" />
                  <div class="mb-5 d-flex mt-10">
                    <h3> 품목계약 마이그레이션 </h3>
                  </div>
                  <div class="d-flex">
                    <div class="mr-5">
                      <v-text-field
                          v-model="contractRentalcompanyId"
                          lavel="rentalcompanyId"
                          placeholder="rentalcompanyId"
                      />
                    </div>
                    <div style="width: 400px;" class="mr-4">
                      <xlsx-controller ref="contractMigrationXlsx" label="migration-data" @fileIsReady="contractMigrationFileIsReady"/>
                    </div>
                    <div class="mt-4 ml-3">
                      <v-btn small color="primary" :disabled="!isContractMigrationFile" @click="onMigrationDataAnalysis('contract')">조회하기</v-btn>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex mb-5">
                      <h4 class="mr-4">성공 데이터</h4>
                      <span class="mr-4"> 총 {{ totalCountOfContractMigration }}개 중 {{ successCountOfContractMigration }}개</span>
                      <v-btn small color="primary" :disabled="!successCountOfContractMigration" @click="downloadSuccessFileOfMigration('contract')">download excel file</v-btn>
                    </div>
                    <div class="d-flex overflow-x-auto data-table-wrap">
                      <table class="data-table">
                        <tr>
                          <th v-for="(h,idx) in contractInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                        </tr>
                        <tr v-for="(s, sIdx) in resultOfContractMigration.checkedDataForExcel.s" :key="`s-${sIdx}`">
                          <td v-for="(h, hIdx) in contractInfoHeaderVerEn" :key="`h-${hIdx}`">{{ s[h] }}</td>
                        </tr>
                        <tr></tr>
                      </table>
                    </div>
                  </div>
                  <div class="mt-5 mb-10">
                    <div class="d-flex mb-5">
                      <h4 class="mr-4">실패 데이터</h4>
                      <span class="mr-4"> 총 {{ totalCountOfContractMigration }} 개중 {{ failCountOfContractMigration }} 개</span>
                      <div class="mr-4">
                        <v-btn small color="primary" :disabled="!failCountOfContractMigration" @click="onReMigrationDataAnalysis('contract')">재조회하기</v-btn>
                      </div>
                      <v-btn class="mr-4" small color="primary" :disabled="!failCountOfContractMigration" @click="downloadFailFilesOfMigration('contract')">download excel file</v-btn>
                    </div>
                    <div class="d-flex overflow-x-auto data-table-wrap">
                      <table class="data-table">
                        <tr>
                          <th style="min-width: 610px">실패이유</th>
                          <th v-for="(h,idx) in contractInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                        </tr>
                        <tr v-for="(f, fIdx) in resultOfContractMigration.checkedDataForExcel.f" :key="`f-${fIdx}`">
                          <td style="width: 500px">
                            <div v-for="(e, eidx) in f.errMsgs" :key="`e-${eidx}`">
                              <div class="d-flex">
                                <div v-for="(t, tidx) in e" :key="`t-${tidx}`">
                                  {{ reasonForFailure(tidx, t) }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-for="(h, hIdx) in contractInfoHeaderVerEn" :key="`h-${hIdx}`">
                            <input type="text" v-model="f[h]"/>
                          </td>
                        </tr>
                        <tr></tr>
                      </table>
                    </div>
                  </div>
                  <div>
                    <div class="mt-4 d-flex">
                      <v-btn width="300" height="50" color="primary" :disabled="!(onClickContractMigrationDataAnalysis && contractRentalcompanyId)" @click="onContractSave">등록하기</v-btn>
                    </div>
                    <div class="d-flex mt-10 mb-10">
                      <div>
                        <div class="d-flex mb-5">
                          <h4>등록 실패</h4>
                          <span class="ml-5"> 품목계약 마이그레이션 성공데이터 {{ successCountOfContractMigration }} 개 중 {{ contractFailCountOfInsert }} 개</span>
                          <v-btn class="ml-4" small color="primary" :disabled="!contractFailCountOfInsert" @click="downloadFailFilesOfInsert('contract')">download excel file</v-btn>
                        </div>
                        <table class="data-table">
                          <tr>
                            <th style="min-width: 400px">
                              거래처
                            </th>
                            <th style="min-width: 600px">
                              이유
                            </th>
                          </tr>
                          <tr v-for="(rf, rfIdx) in contractResultOfInsert.failData" :key="`rf-${rfIdx}`">
                            <td> {{ rf.accountId }} </td>
                            <td> {{ rf.msg }} </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <hr style="margin-top: 200px;" />
                  <hr class="mt-2" />
                  <div class="mb-5 d-flex mt-10">
                    <h3> 세금계산서 마이그레이션 </h3>
                  </div>
                  <div class="d-flex">
                    <div class="mr-5">
                      <v-text-field
                          v-model="taxRentalcompanyId"
                          lavel="rentalcompanyId"
                          placeholder="rentalcompanyId"
                      />
                    </div>
                    <div style="width: 400px;" class="mr-4">
                      <xlsx-controller ref="taxMigrationXlsx" label="migration-data" @fileIsReady="taxMigrationFileIsReady"/>
                    </div>
                    <div class="mt-4 ml-3">
                      <v-btn small color="primary" :disabled="!isTaxMigrationFile" @click="onMigrationDataAnalysis('tax')">조회하기</v-btn>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex mb-5">
                      <h4 class="mr-4">성공 데이터</h4>
                      <span class="mr-4"> 총 {{ totalCountOfTaxMigration }}개 중 {{ successCountOfTaxMigration }}개</span>
                      <v-btn small color="primary" :disabled="!successCountOfTaxMigration" @click="downloadSuccessFileOfMigration('tax')">download excel file</v-btn>
                    </div>
                    <div class="d-flex overflow-x-auto data-table-wrap">
                      <table class="data-table">
                        <tr>
                          <th v-for="(h,idx) in taxInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                        </tr>
                        <tr v-for="(s, sIdx) in resultOfTaxMigration.checkedDataForExcel.s" :key="`s-${sIdx}`">
                          <td v-for="(h, hIdx) in taxInfoHeaderVerEn" :key="`h-${hIdx}`">{{ s[h] }}</td>
                        </tr>
                        <tr></tr>
                      </table>
                    </div>
                  </div>
                  <div class="mt-5 mb-10">
                    <div class="d-flex mb-5">
                      <h4 class="mr-4">실패 데이터</h4>
                      <span class="mr-4"> 총 {{ totalCountOfTaxMigration }} 개중 {{ failCountOfTaxMigration }} 개</span>
                      <div class="mr-4">
                        <v-btn small color="primary" :disabled="!failCountOfTaxMigration" @click="onReMigrationDataAnalysis('tax')">재조회하기</v-btn>
                      </div>
                      <v-btn class="mr-4" small color="primary" :disabled="!failCountOfTaxMigration" @click="downloadFailFilesOfMigration('tax')">download excel file</v-btn>
                    </div>
                    <div class="d-flex overflow-x-auto data-table-wrap">
                      <table class="data-table">
                        <tr>
                          <th style="min-width: 610px">실패이유</th>
                          <th v-for="(h,idx) in taxInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                        </tr>
                        <tr v-for="(f, fIdx) in resultOfTaxMigration.checkedDataForExcel.f" :key="`f-${fIdx}`">
                          <td style="width: 500px">
                            <div v-for="(e, eidx) in f.errMsgs" :key="`e-${eidx}`">
                              <div class="d-flex">
                                <div v-for="(t, tidx) in e" :key="`t-${tidx}`">
                                  {{ reasonForFailure(tidx, t) }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-for="(h, hIdx) in taxInfoHeaderVerEn" :key="`h-${hIdx}`">
                            <input type="text" v-model="f[h]"/>
                          </td>
                        </tr>
                        <tr></tr>
                      </table>
                    </div>
                  </div>
                  <div>
                    <div class="mt-4 d-flex">
                      <v-btn width="300" height="50" color="primary" :disabled="!(onClickTaxMigrationDataAnalysis && taxRentalcompanyId)" @click="onTaxSave">등록하기</v-btn>
                    </div>
                    <div class="d-flex mt-10 mb-10">
                      <div>
                        <div class="d-flex mb-5">
                          <h4>등록 실패</h4>
                          <span class="ml-5"> 세금계산서 마이그레이션 성공데이터 {{ successCountOfTaxMigration }} 개 중 {{ taxFailCountOfInsert }} 개</span>
                          <v-btn class="ml-4" small color="primary" :disabled="!taxFailCountOfInsert" @click="downloadFailFilesOfInsert('tax')">download excel file</v-btn>
                        </div>
                        <table class="data-table">
                          <tr>
                            <th style="min-width: 400px">
                              거래처
                            </th>
                            <th style="min-width: 600px">
                              이유
                            </th>
                          </tr>
                          <tr v-for="(rf, rfIdx) in taxResultOfInsert.failData" :key="`rf-${rfIdx}`">
                            <td> {{ rf.accountId }} </td>
                            <td> {{ rf.msg }} </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                    <hr style="margin-top: 200px;" />
                    <hr class="mt-2" />
                    <div class="mb-5 d-flex mt-10">
                        <h3> 최종 마이그레이션 </h3>
                    </div>
                    <div class="d-flex">
                      <div class="mr-5">
                        <v-text-field
                            v-model="totalRentalcompanyId"
                            lavel="rentalcompanyId"
                            placeholder="rentalcompanyId"
                        />
                      </div>
                        <div style="width: 400px;" class="mr-4">
                            <xlsx-controller ref="migrationXlsx" label="migration-data" @fileIsReady="migrationFileIsReady"/>
                        </div>
                        <div class="mt-4 ml-3">
                            <v-btn small color="primary" :disabled="!isMigrationFile" @click="onMigrationDataAnalysis">조회하기</v-btn>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex mb-5">
                            <h4 class="mr-4">성공 데이터</h4>
                            <span class="mr-4"> 총 {{ totalCountOfMigration }}개 중 {{ successCountOfMigration }}개</span>
                            <v-btn small color="primary" :disabled="!successCountOfMigration" @click="downloadSuccessFileOfMigration">download excel file</v-btn>
                        </div>
                        <div class="d-flex overflow-x-auto data-table-wrap">
                            <table class="data-table">
                                <tr>
                                    <th v-for="(h,idx) in baseInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                                </tr>
                                <tr v-for="(s, sIdx) in resultOfMigration.checkedDataForExcel.s" :key="`s-${sIdx}`">
                                    <td v-for="(h, hIdx) in baseInfoHeaderVerEn" :key="`h-${hIdx}`">{{ s[h] }}</td>
                                </tr>
                                <tr></tr>
                            </table>
                        </div>
                    </div>
                    <div class="mt-5 mb-10">
                        <div class="d-flex mb-5">
                            <h4 class="mr-4">실패 데이터</h4>
                            <span class="mr-4"> 총 {{ totalCountOfMigration }} 개중 {{ failCountOfMigration }} 개</span>
                            <div class="mr-4">
                                <v-btn small color="primary" :disabled="!failCountOfMigration" @click="onReMigrationDataAnalysis">재조회하기</v-btn>
                            </div>
                            <v-btn class="mr-4" small color="primary" :disabled="!failCountOfMigration" @click="downloadFailFilesOfMigration">download excel file</v-btn>
                        </div>
                        <div class="d-flex overflow-x-auto data-table-wrap">
                            <table class="data-table">
                                <tr>
                                    <th style="min-width: 610px">실패이유</th>
                                    <th v-for="(h,idx) in baseInfoHeader" :key="idx" style="min-width: 200px;">{{ h }}</th>
                                </tr>
                                <tr v-for="(f, fIdx) in resultOfMigration.checkedDataForExcel.f" :key="`f-${fIdx}`">
                                    <td style="width: 500px">
                                        <div v-for="(e, eidx) in f.errMsgs" :key="`e-${eidx}`">
                                            <div class="d-flex">
                                                <div v-for="(t, tidx) in e" :key="`t-${tidx}`">
                                                    {{ reasonForFailure(tidx, t) }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-for="(h, hIdx) in baseInfoHeaderVerEn" :key="`h-${hIdx}`">
                                        <input type="text" v-model="f[h]"/>
                                    </td>
                                </tr>
                                <tr></tr>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div class="mt-4 d-flex">
                            <v-btn width="300" height="50" color="primary" :disabled="!(onClickMigrationDataAnalysis&&totalRentalcompanyId)" @click="onSave">등록하기</v-btn>
                        </div>
                        <div class="d-flex mt-10 mb-10">
                            <div>
                                <div class="d-flex mb-5">
                                    <h4>등록 실패</h4>
                                    <span class="ml-5"> 최종마이그레이션 성공데이터 {{ successCountOfMigration }} 개 중 {{ failCountOfInsert }} 개</span>
                                    <v-btn class="ml-4" small color="primary" :disabled="!failCountOfInsert" @click="downloadFailFilesOfInsert">download excel file</v-btn>
                                </div>
                                <table class="data-table">
                                    <tr>
                                        <th style="min-width: 400px">
                                            거래처
                                        </th>
                                        <th style="min-width: 600px">
                                            이유
                                        </th>
                                    </tr>
                                    <tr v-for="(rf, rfIdx) in resultOfInsert.failData" :key="`rf-${rfIdx}`">
                                        <td> {{ rf.accountName }} </td>
                                        <td> {{ rf.msg }} </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <hr style="margin-top: 200px;" />
                    <hr class="mt-2" />
                    <div>
                        <div class="d-flex mt-10 mb-10">
                            <div>
                                <div class="d-flex mb-3">
                                    <h4>마이그레이션 데이터 삭제</h4>
                                </div>
                                <div class="d-flex mb-5 justify-start align-center" style="width: 500px;">
                                    <v-text-field
                                            label="임대업체번호를 입력해주세요"
                                            type="number"
                                            v-model="deleteRentalcompanyNumber"
                                    ></v-text-field>
                                    <v-btn class="ml-4" small color="primary" @click="deleteRentalcompany">삭제</v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main-body>
        </template>
    </main-layout>
</template>

<script>
    import {PATH} from "@/constants";
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainBody from "@/components/common/layout/MainBody";
    import MainToolbar from "@/components/common/layout/MainToolbar";
    import MainHeader from "@/components/common/layout/MainHeader";
    import XlsxController from "../../../../framework/excel/XlsxController";
    import DataMigrationBaseInfo from "./dataMigrationBaseInfo";
    import DataMigrationCMSInfo from "./dataMigrationCMSInfo";
    import AccountDataMigration from "./dataMigrationInfo";

    export default {
        name: "DataMigrationWindow",
        components : {
            MainHeader,
            MainToolbar,
            MainBody,
            MainLayout,
            XlsxController
        },
        data(){
            return {
                cmsTypes: [{ text: "효성", value: "H"}, { text: "나이스", value: "N"}],
                cmsType: 'H',
                loading: false,
                isCmsInfoFile: false,
                isBaseInfoFile: false,
                isMigrationFile: false,
                isTaxMigrationFile: false,
                isContractMigrationFile: false,
                baseInfo: null,
                baseInfoHeader: [],
                taxInfoHeader: [],
                contractInfoHeader: [],
                baseInfoHeaderVerEn: [],
                taxInfoHeaderVerEn: [],
                contractInfoHeaderVerEn: [],
                baseInfoHeaderRange: 'A6:BW6',
                taxInfoHeaderRange: 'A6:P6',
                constInfoHeaderRange: 'A6:V6',
                baseInfoHeaderStartVerEn: 'A2',
                baseInfoContentStart: 'A6',
                cmsInfo: null,
                migrationData: null,
                taxMigrationData: null,
                contractMigrationData: null,
                resultOfMerge: {
                    mergedData: [],
                    failedData: [],
                    onlyCMSData: [],
                    duplicateCMSData: [],
                    cmsOriginData: []
                },
                resultOfMigration: {
                    successData: {},
                    failData: {},
                    checkedData: [],
                    checkedDataForExcel: { 's': [], 'f': []},
                },
                resultOfTaxMigration: {
                    successData: {},
                    failData: {},
                    checkedData: [],
                    checkedDataForExcel: { 's': [], 'f': []},
                },
                resultOfContractMigration: {
                    successData: {},
                    failData: {},
                    checkedData: [],
                    checkedDataForExcel: { 's': [], 'f': []},
                },
                resultOfInsert: {
                    successData: [],
                    failData: [],
                    failDataForExcel: [],
                },
                taxResultOfInsert: {
                    successData: [],
                    failData: [],
                    failDataForExcel: [],
                },
                contractResultOfInsert: {
                    successData: [],
                    failData: [],
                    failDataForExcel: [],
                },
                resultOfOnlyCms: {
                    totalCount: 0,
                    successData: [],
                    failData: [],
                    failDataForExcel: [],
                },
                onClickMigrationDataAnalysis: false,
                onClickTaxMigrationDataAnalysis: false,
                onClickContractMigrationDataAnalysis: false,
                deleteRentalcompanyNumber: null,
                rentalcompanyId: null,
                totalRentalcompanyId: null,
                taxRentalcompanyId: null,
                contractRentalcompanyId: null,
            }
        },
        computed: {
            totalCountOfBaseInfo(){
                return this.resultOfMerge.mergedData.length + this.resultOfMerge.failedData.length;
            },
            totalCountOfCmsInfo(){
                return this.resultOfMerge.cmsOriginData.length;
            },
            successCountOfBaseInfo(){
                return this.resultOfMerge.mergedData.length;
            },
            failCountOfBaseInfo(){
                return this.resultOfMerge.failedData.length;
            },
            failCountOfCmsInfo(){
                return this.resultOfMerge.onlyCMSData.length + this.resultOfMerge.duplicateCMSData.length;
            },
            totalCountOfMigration(){
                return this.resultOfMigration?.checkedDataForExcel?.s.length + this.resultOfMigration?.checkedDataForExcel?.f.length;
            },
            successCountOfMigration(){
                return this.resultOfMigration?.checkedDataForExcel?.s.length;
            },
            failCountOfMigration(){
                return this.resultOfMigration?.checkedDataForExcel?.f.length;
            },
            totalCountOfTaxMigration(){
                return this.resultOfTaxMigration?.checkedDataForExcel?.s.length + this.resultOfTaxMigration?.checkedDataForExcel?.f.length;
            },
            successCountOfTaxMigration(){
                return this.resultOfTaxMigration?.checkedDataForExcel?.s.length;
            },
            failCountOfTaxMigration(){
                return this.resultOfTaxMigration?.checkedDataForExcel?.f.length;
            },
            totalCountOfContractMigration(){
                return this.resultOfContractMigration?.checkedDataForExcel?.s.length + this.resultOfContractMigration?.checkedDataForExcel?.f.length;
            },
            successCountOfContractMigration(){
                return this.resultOfContractMigration?.checkedDataForExcel?.s.length;
            },
            failCountOfContractMigration(){
                return this.resultOfContractMigration?.checkedDataForExcel?.f.length;
            },
            successCountOfInsert(){
                return this.resultOfInsert.successData.length;
            },
            failCountOfInsert(){
                return this.resultOfInsert.failData.length;
            },
            taxFailCountOfInsert(){
                return this.taxResultOfInsert.failData.length;
            },
            contractFailCountOfInsert(){
                return this.contractResultOfInsert.failData.length;
            },
            successCountOfOnlyCms(){
                return this.resultOfOnlyCms.successData.length;
            },
            failCountOfOnlyCms(){
                return this.resultOfOnlyCms.failData.length;
            }


        },
        methods: {
            onCmsTypeChange(e){
                this.cmsType = e;
            },
            reasonForFailure(tidx, msg){
                switch (tidx) {
                    case 0:
                        return `${msg} => `;
                    case 1:
                        return `${msg} `;
                    case 2:
                        return msg;
                    case 3:
                        return msg.join(' or ');
                }
            },

            cmsInfoFileIsReady(v){
                this.isCmsInfoFile = v;
            },

            baseInfoFileIsReady(v){
                this.isBaseInfoFile = v;
            },

            migrationFileIsReady(v){
                this.isMigrationFile = v;
            },

            taxMigrationFileIsReady(v){
                this.isTaxMigrationFile = v;
            },
            contractMigrationFileIsReady(v){
                this.isContractMigrationFile = v;
            },

            async setBaseInfo(){

                // 기본정보 생성
                const baseInfo = this.$refs['baseInfoXlsx'];
                await baseInfo.create(this.baseInfoContentStart);


                // header 생성
                const keysOfEn = baseInfo.getWS(2, this.baseInfoHeaderStartVerEn)?.map(o => o['컬럼명']) || [];
                const keysOfKr = baseInfo.getHeaderArr(0, this.baseInfoHeaderRange)[0] || [];
                this.baseInfoHeader = keysOfKr;
                this.baseInfoHeaderVerEn = keysOfEn;
                const keys = {'kr': keysOfKr, 'en': keysOfEn};

                // 기본정보 데이터 생성
                this.baseInfo = new DataMigrationBaseInfo(baseInfo.firstWorkSheet, keys);
                this.baseInfo.init();
            },

            async setCmsInfo(){
                // CMS정보 생성
                const cmsInfo = this.$refs['cmsInfoXlsx'];
                await cmsInfo.create();

                // CMS 데이터 생성
                this.cmsInfo = new DataMigrationCMSInfo(cmsInfo.firstWorkSheet, this.cmsType);
                this.cmsInfo.init();
            },

            async onAnalysis() {
                this.loading = true;
                await this.setBaseInfo();
                await this.setCmsInfo();

                const cmsInfoNames = this.cmsInfo.itemNames;
                const cmsInfoArray = this.cmsInfo.items;
                const { mergedData, failedData, onlyCMSData, duplicateCMSData, cmsOriginData } = this.baseInfo?.mergeData(cmsInfoNames, cmsInfoArray);

                this.resultOfMerge.mergedData = mergedData;
                this.resultOfMerge.failedData = failedData;
                this.resultOfMerge.onlyCMSData = onlyCMSData;
                this.resultOfMerge.duplicateCMSData = duplicateCMSData;
                this.resultOfMerge.cmsOriginData = cmsOriginData;
                this.loading = false;
            },

            async onOnlyCmsRegister(){
                this.loading = true;
                const cmsInfo = this.$refs['onlyCmsXlsx'];
                await cmsInfo.create();

                // CMS 데이터 생성
                this.cmsInfo = new DataMigrationCMSInfo(cmsInfo.firstWorkSheet, this.cmsType);
                this.cmsInfo.onlyCmsInfoInit();
                const data = {
                    rentalcompanyId: this.rentalcompanyId,
                    list: this.cmsInfo.items
                }

                try {
                    const res = await this.insertOnlyCmsData(data);
                    this.$toasted.success('등록되었습니다.');

                    console.log('!!!!!!!! res : ', res)


                    this.resultOfOnlyCms.successData = res.success;
                    this.resultOfOnlyCms.failData = res.fail;
                    this.resultOfOnlyCms.totalCount = res.failCount + res.successCount;

                } catch (e) {
                    console.log(e)
                }

                this.loading = false;


            },




            downloadBaseInfoFile(data, fileName) {
                const xlsx = this.$refs['baseInfoXlsx'];
                const arr = this.baseInfo.dataToArray(data)
                const wb = xlsx.newWorkbookWithDataChange(0, arr, this.baseInfoContentStart);
                xlsx.writeFile(wb, fileName);
            },

            downloadMigrationFile(data, fileName, type) {
              let xlsx
              let migData
              if(type === 'tax'){
                xlsx = this.$refs['taxMigrationXlsx']
                migData = this.taxMigrationData
              } else if (type === 'contract'){
                xlsx = this.$refs['contractMigrationXlsx']
                migData = this.contractMigrationData
              } else {
                migData = this.migrationData
                xlsx = this.$refs['migrationXlsx'];
              }
                const arr = migData.dataToArray(data)
                const wb = xlsx.newWorkbookWithDataChange(0, arr, this.baseInfoContentStart);
                xlsx.writeFile(wb, fileName);
            },


            downloadCMSInfoFile(fileName) {
                const xlsx = this.$refs['cmsInfoXlsx'];
                const arr = this.cmsInfo.dataToArray();
                const wb = xlsx.newWorkbookWithDataChange(0, arr, "A1");
                xlsx.writeFile(wb, fileName);
            },

            downloadFailFiles(){
                this.downloadFailFileOfBaseInfo();
                this.downloadCMSInfoFile('failed-cms-data.xlsx')
            },

            downloadSuccessFile(){
                if(this.resultOfMerge.mergedData.length > 0){
                    this.downloadBaseInfoFile(this.resultOfMerge.mergedData, 'merged-data.xlsx');
                } else {
                    this.$alert('merge 된 데이터가 없습니다.');
                }

            },

            downloadFailFileOfBaseInfo(){
                this.downloadBaseInfoFile(this.resultOfMerge.failedData, 'failed-base-data.xlsx');
            },

            downloadFailFilesOfMigration(type){
                let result
                if(type === 'tax'){
                  result = this.resultOfTaxMigration
                } else if (type === 'contract'){
                  result = this.resultOfContractMigration
                } else {
                  result = this.resultOfMigration
                }
                this.downloadMigrationFile(result.checkedDataForExcel.f, 'failed-migration-data.xlsx',type);
            },

            downloadSuccessFileOfMigration(type){
              let result
              if(type === 'tax'){
                result = this.resultOfTaxMigration
              } else if (type === 'contract'){
                result = this.resultOfContractMigration
              } else {
                result = this.resultOfMigration
              }
                this.downloadMigrationFile(result.checkedDataForExcel.s, 'success-migration-data.xlsx',type);
            },


            downloadFailFilesOfInsert(type){
              let result
              if(type === 'tax'){
                result = this.taxResultOfInsert
              } else if (type === 'contract'){
                result = this.contractResultOfInsert
              } else {
                result = this.resultOfInsert
              }
                this.downloadMigrationFile(result.failDataForExcel, 'failed-insert-data.xlsx',type);
            },

            insertData(data){
                return this.$request(PATH.MIGRATION.INSERT + this.totalRentalcompanyId)
                    .setObject(data)
                    .catch();
            },

           insertContractData(data){
            return  this.$request(PATH.MIGRATION.CONTRACT_INSERT + this.contractRentalcompanyId)
                    .setObject(data).enqueue()
                    .catch();

            },

            insertTaxData(data){
                return this.$request(PATH.MIGRATION.TAX_INSERT + this.taxRentalcompanyId)
                    .setObject(data).enqueue()
                    .catch();
            },

            insertOnlyCmsData(data){
                return this.$request(PATH.MIGRATION.CMS_INSERT)
                    .setObject(data)
                    .catch()
                    .enqueue();
            },


            async setMigrationData(type){
              let M
              let range // 엑셀헤더범위
              if(type === 'tax'){
                 M = this.$refs['taxMigrationXlsx']
                 range = this.taxInfoHeaderRange
              }else if(type === 'contract'){
                  M = this.$refs['contractMigrationXlsx']
                 range = this.constInfoHeaderRange
              } else {
                M = this.$refs['migrationXlsx'];
                 range = this.baseInfoHeaderRange
              }

              // 마이그레이션 데이터 생성
              await M.create(this.baseInfoContentStart);

              // header 생성
              const keysOfEn = M.getWS(2, this.baseInfoHeaderStartVerEn)?.map(o => o['컬럼명']) || [];
              const keysOfKr = M.getHeaderArr(0, range)[0] || [];
              let keys = {'kr': keysOfKr, 'en': keysOfEn};

                // 기본정보 데이터 생성
              if(type === 'tax'){
                this.taxInfoHeader = keysOfKr;
                this.taxInfoHeaderVerEn = keysOfEn;
                this.taxMigrationData = new AccountDataMigration(M.firstWorkSheet, keys);
                this.taxMigrationData.init();
              } else if(type === 'contract') {
                this.contractInfoHeader = keysOfKr;
                this.contractInfoHeaderVerEn = keysOfEn;
                this.contractMigrationData = new AccountDataMigration(M.firstWorkSheet, keys);
                this.contractMigrationData.init();
              } else {
                this.baseInfoHeader = keysOfKr;
                this.baseInfoHeaderVerEn = keysOfEn;
                this.migrationData = new AccountDataMigration(M.firstWorkSheet, keys);
                this.migrationData.init();
              }

            },

            async onMigrationDataAnalysis(type) {
                this.loading = true;
                await this.setMigrationData(type);

                let data
                if(type === 'tax'){
                  data = this.taxMigrationData
                } else if (type === 'contract'){
                  data = this.contractMigrationData
                } else {
                  data = this.migrationData
                }

                const items = data.items

                try{

                const { successData, failData, checkedData, checkedDataForExcel} = data.dataClearAndValidCheck(items, type);

                if(type === 'tax'){
                  this.resultOfTaxMigration.successData = successData;
                  this.resultOfTaxMigration.failData = failData;
                  this.resultOfTaxMigration.checkedData = checkedData;
                  this.resultOfTaxMigration.checkedDataForExcel = checkedDataForExcel;
                  this.onClickTaxMigrationDataAnalysis = true;
                } else if(type === 'contract') {
                  this.resultOfContractMigration.successData = successData;
                  this.resultOfContractMigration.failData = failData;
                  this.resultOfContractMigration.checkedData = checkedData;
                  this.resultOfContractMigration.checkedDataForExcel = checkedDataForExcel;
                  this.onClickContractMigrationDataAnalysis = true;
                } else {
                  this.resultOfMigration.successData = successData;
                  this.resultOfMigration.failData = failData;
                  this.resultOfMigration.checkedData = checkedData;
                  this.resultOfMigration.checkedDataForExcel = checkedDataForExcel;
                  this.onClickMigrationDataAnalysis = true;
                }

              } catch (e) {
                console.log('tax migration error:', e)
                this.$alert('오류가 발생했습니다. 해당 파일이 맞는지 확인해주세요.')
                this.loading = false;
                return
            }


                this.loading = false;
            },

            async onReMigrationDataAnalysis(type){
                let items
                if(type === 'tax'){
                  items = this.resultOfTaxMigration.checkedDataForExcel.f;
                } else if (type === 'contract'){
                  items = this.resultOfContractMigration.checkedDataForExcel.f;
                } else {
                  items = this.resultOfMigration.checkedDataForExcel.f;
                }

                let data
                if(type === 'tax'){
                  data = this.taxMigrationData
                } else if (type === 'contract'){
                  data = this.contractMigrationData
                } else {
                  data = this.migrationData
                }

                if(items.length > 0){
                    const { successData, failData, checkedData, checkedDataForExcel} = data.dataClearAndValidCheck(items, type);

                    if(type === 'tax'){
                      this.resultOfTaxMigration.successData = { ...this.resultOfTaxMigration.successData, ...successData};
                      this.resultOfTaxMigration.failData = failData;
                      this.resultOfTaxMigration.checkedDataForExcel.s = this.resultOfTaxMigration.checkedDataForExcel.s.concat(checkedDataForExcel.s);
                      this.resultOfTaxMigration.checkedDataForExcel.f = checkedDataForExcel.f;
                    } else if (type === 'contract'){
                      this.resultOfContractMigration.successData = { ...this.resultOfContractMigration.successData, ...successData};
                      this.resultOfContractMigration.failData = failData;
                      this.resultOfContractMigration.checkedDataForExcel.s = this.resultOfContractMigration.checkedDataForExcel.s.concat(checkedDataForExcel.s);
                      this.resultOfContractMigration.checkedDataForExcel.f = checkedDataForExcel.f;
                    } else {
                      this.resultOfMigration.successData = { ...this.resultOfMigration.successData, ...successData};
                      this.resultOfMigration.failData = failData;
                      this.resultOfMigration.checkedDataForExcel.s = this.resultOfMigration.checkedDataForExcel.s.concat(checkedDataForExcel.s);
                      this.resultOfMigration.checkedDataForExcel.f = checkedDataForExcel.f;
                    }

                } else {
                    this.$alert('재조회 할 정보가 없습니다.')
                }
            },

            async onSave(){
                const data = Object.values(this.resultOfMigration.successData);
                if(data.length > 0){
                    this.loading = true;
                    this.resultOfInsert.successData = [];
                    this.resultOfInsert.failData = [];
                    this.resultOfInsert.failDataForExcel = [];

                    // 업체당 cms 1개만 registerYn 값을 'Y'로 보낸다.
                    data.forEach(d =>{
                      d.some(item=> {
                        if(item.cmsId){
                          item.registerYn = 'Y'
                          return true
                        }
                      })
                    })

                    const promiseData = data.map(d => this.insertData(d))

                    for (const p of promiseData) {
                        const r = await p.enqueue().catch(e => e.response);
                        if(r.config){
                            let errMsg = '';
                            switch (r.data.code) {
                                case -9802:
                                    errMsg = '임대업체 번호가 잘못되었습니다.'
                                    break;
                                case -9000:
                                    errMsg = '같은 이름의 거래처가 있습니다. 삭제 후 등록해주세요.'
                                    break;
                                case -9002:
                                    errMsg = 'CMS 정보 오류로 등록이 되지 못했습니다. CMS 정보를 확인해주세요.'
                                    break;
                                case -9003:
                                    errMsg = '세금계산서 정보 오류로 등록이 되지 못했습니다. 세금계산서 정보를 확인해주세요.'
                                    break;
                                case -9004:
                                    errMsg = '계약 정보 오류로 등록이 되지 못했습니다. 계약 정보를 확인해주세요.'
                                    break;
                                case -9005:
                                    errMsg = '프린터 정보 오류로 등록이 되지 못했습니다. 프린터 정보를 확인해주세요.'
                                    break;
                            }

                            const company = JSON.parse(r.config.data);
                            this.resultOfInsert.failDataForExcel = this.resultOfInsert.failDataForExcel.concat(company);
                            this.resultOfInsert.failData.push({ accountName: company[0].accountName, msg: errMsg})


                        // 등록 성공 데이터
                        } else {
                            this.resultOfInsert.successData.push(r.data[0]);
                        }
                    }

                    this.$toasted.success('등록되었습니다.');
                    this.loading = false;
                } else {
                    this.$alert('등록할 데이터가 없습니다.')
                }
            },

          async onContractSave() {
              const data = Object.values(this.resultOfContractMigration.successData);
              if (data.length > 0) {
                this.loading = true;
                this.contractResultOfInsert.successData = [];
                this.contractResultOfInsert.failData = [];
                this.contractResultOfInsert.failDataForExcel = [];

                let dataList = []
                data.forEach(e=> {
                  dataList.push(...e)
                })

                const result = await this.insertContractData(dataList)

                if (result) {
                  let errMsg = '';
                  result.data.forEach(e=> {
                    if (e.message) {
                      errMsg = e.message.message
                      const company = e
                      this.contractResultOfInsert.failDataForExcel = this.contractResultOfInsert.failDataForExcel.concat(company);
                      this.contractResultOfInsert.failData.push({accountId: company.accountId, msg: errMsg})


                    } else {
                      // 등록 성공 데이터
                      this.contractResultOfInsert.successData.push(e);
                    }

                  })
                }


                this.$toasted.success('등록되었습니다.');
                this.loading = false;
              } else {
                this.$alert('등록할 데이터가 없습니다.')
              }
            },

            async onTaxSave() {
              const data = Object.values(this.resultOfTaxMigration.successData);
              if (data.length > 0) {
                this.loading = true;
                this.resultOfTaxMigration.successData = [];
                this.resultOfTaxMigration.failData = [];
                this.resultOfTaxMigration.failDataForExcel = [];

                let dataList = []
                data.forEach(e=> {
                  dataList.push(...e)
                })

                const result = await this.insertTaxData(dataList)

                if (result) {
                  let errMsg = '';
                  result.data.forEach(e=> {
                    if (e.resultMessage) {
                      errMsg = e.resultMessage.message
                      const company = e
                      this.taxResultOfInsert.failDataForExcel = this.taxResultOfInsert.failDataForExcel.concat(company);
                      this.taxResultOfInsert.failData.push({accountId: company.accountId, msg: errMsg})

                    } else {
                      // 등록 성공 데이터
                      this.taxResultOfInsert.successData.push(e);
                    }

                  })
                }

                this.$toasted.success('등록되었습니다.');
                this.loading = false;
              } else {
                this.$alert('등록할 데이터가 없습니다.')
              }
            },


            allDelete(rentalCompanyId){
                return this.$request(PATH.MIGRATION.DELETE + rentalCompanyId)
                    .get()
                    .catch()
                    .enqueue();
            },


            deleteRentalcompany(){
                this.$confirm("정말 삭제하시겠습니까?")
                .then(async() => {
                    if(this.deleteRentalcompanyNumber){
                        const rentalCompanyId = this.deleteRentalcompanyNumber.toString();

                        try {
                            await this.allDelete(rentalCompanyId);
                            this.$nextTick(() => {
                                this.$toasted.success('삭제되었습니다.');
                                this.deleteRentalcompanyNumber = null;
                            })
                        } catch (e) {
                            this.$toasted.error('서버에서 에러가 발생하였습니다');
                        }

                    } else {
                        this.$alert('삭제 할 임대업체 번호를 입력해주세요')
                    }

                })

            }

        }

    }
</script>

<style scoped>
.body-container {
    width: 100%;
    height: 100%;
    padding-right: 20px;
    overflow-y: scroll;
}

.data-table-wrap {
    height: 500px;
    overflow-y: scroll;
}


.data-table {
    width: 100%;
    border: 1px solid grey;
    background-color: white;
}

.data-table tr th {
    height: 50px;
    max-height: 50px;
    border-right: 1px solid grey;
    border-bottom: 1px solid grey;
    position: sticky;
    top: 0px;
    background-color: lightgray;
}

.data-table tr td {
    height: 60px;
    border-right: 1px solid grey;
    border-bottom: 1px solid grey;
    background-color: white;
}

hr {
    border-color: #2B3F54;
}


</style>